require('mmenu-js/src/mmenu.scss');
require('./styles/main.scss');

import Mmenu from 'mmenu-js';

function alignMegaMenus() {
  const headerNav = document.querySelector('header nav');
  if (headerNav) {
    const withSubmenu = headerNav.querySelectorAll('.level_1 > .submenu > a');
    withSubmenu.forEach(link => {
      link.addEventListener('mouseover', function (event) {
        const ul = link.parentElement.querySelector('.level_2');
        if (ul) {
          const navRect = headerNav.getBoundingClientRect()
          const linkRect = link.getBoundingClientRect();
          const ulRect = ul.getBoundingClientRect();
          if (linkRect.x + ulRect.width > navRect.x + navRect.width) {
            ul.classList.add('align-right');
          } else {
            ul.classList.remove('align-right')
          }
        }
      })
    })
  }
}

function createOffcanvasMenu() {
  new Mmenu("#menu", {
      offCanvas: {
        use: true,
      },
      theme: 'dark',
      navbar: {
        title: 'Landestanzsportverband Berlin'
      },
      slidingSubmenus: true,
    },
    {
      language: 'de',
      offCanvas: {
        clone: true
      }
    }
  );
}

function executeYtCommand(iframe, func) {
  if (iframe.contentWindow.postMessage) {
    iframe.contentWindow.postMessage(JSON.stringify({event: 'command', func, args: []}), '*')
  }
}

function createAndShowGestureVideoDialog(dialogId) {
  let dialog = document.getElementById(dialogId);
  let button;
  if (!dialog) {
    dialog = document.createElement('dialog');
    dialog.id = dialogId;
    dialog.classList.add('accessibility-by-gesture-dialog');

    const div = document.createElement('div');
    div.classList.add('controls');
    button = document.createElement('button');
    button.innerHTML = '<i class="fas fa-times"></i>';
    button.classList.add('close');
    button.addEventListener('click', () => {
      dialog.close();
    });
    div.appendChild(button);
    dialog.appendChild(div);

    dialog.appendChild(document.querySelector('#accessibility-by-gesture'));
  }

  const iframe = dialog.querySelector('.ce_youtube iframe');
  if (iframe) {
    if (dialog.parentNode === null) {
      dialog.addEventListener('close', () => {
        executeYtCommand(dialog.querySelector('.ce_youtube iframe'), 'pauseVideo');
      });
      document.body.appendChild(dialog);
    } else {
      executeYtCommand(iframe, 'playVideo');
    }
  }

  if (!dialog.open) {
    dialog.showModal();
    button?.focus();
  }
}

function accessibilityByGestureIntegration(selectorButton, selectorVideo) {
  const button = document.querySelector(selectorButton);
  if (!button) {
    return;
  }

  const video = document.querySelector(selectorVideo);
  if (!video) {
    return;
  }

  button.addEventListener('click', createAndShowGestureVideoDialog.bind(null, 'accessibility-by-gesture-dialog'));
  button.classList.remove('disabled');
}

function klaroPrivacySettingsIntegration(selectorButton, modal) {
  const button = document.querySelector(selectorButton);
  if (!button) {
    return;
  }

  button.addEventListener('click', function (event) {
    klaro.show(undefined, modal);
    event.preventDefault();
  });
}

document.addEventListener(
  'DOMContentLoaded', () => {
    alignMegaMenus();
    createOffcanvasMenu();
    accessibilityByGestureIntegration('#show-sign-language', '#accessibility-by-gesture .inside .mod_article:first-child .ce_youtube:first-child');
    klaroPrivacySettingsIntegration('#show-privacy-settings', true);
  }
);

window.addEventListener('scroll', () => {
  const header = document.querySelector('#header') || document.body;
  const isShrinked = header.classList.contains('shrinked');
  const shrinkAt = 200;
  const shrinkBy = 15;

  const distanceY = window.scrollY || 0,
    shrinkOn = isShrinked ? shrinkAt - shrinkBy : shrinkAt;

  if (distanceY > shrinkOn) {
    if (!isShrinked) {
      document.body.classList.add('shrinked-header');
      header.classList.add('shrinked');
    }
  } else {
    if (isShrinked) {
      document.body.classList.remove('shrinked-header');
      header.classList.remove('shrinked');
    }
  }
}, {passive: true});
